import tribunalAPI from "api/tribunalAPi";
import axios from "axios";
import { ValidateStatus } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";

let source = axios.CancelToken.source();

const postValidarStatusSign = async (body: any) => {
  let url = "firma-electronica/validar-estatus";
  return await tribunalAPI.post<ValidateStatus>(url, body);
};

const postDerFimaElectronica = async (body: any) => {
  let url = "firma-electronica/der";
  return await tribunalAPI.post(url, body);
};

const postVector = async (body: any) => {
  let url = "firma-electronica/vector";
  return await tribunalAPI.post(url, body, {
    cancelToken: source.token,
  });
};

const postFirmaArchivosExtendidos = async (body: any) => {
  let url = "firma-electronica/firma-archivos-extendido";
  return await tribunalAPI.post(url, body);
};

const postTerminarFirmaAnticipada = async (body: any) => {
  let url = "firma-electronica/terminar-firma-anticipada";
  return await tribunalAPI.post(url, body);
};

export {
  postDerFimaElectronica,
  postVector,
  postFirmaArchivosExtendidos,
  postValidarStatusSign,
  postTerminarFirmaAnticipada,
};
